import { FC } from "react";
import { VscLoading } from "react-icons/vsc";
import FormContainer from "./form";
import Thumbnail from "./thumbnail";
import Banner from "./banner";
import Static from "./static";

interface Props {
    data: IArticle["get"];
    loading: boolean;
}

const EditArticleContainer: FC<Props> = ({ data, loading }) => {
    return (
        <div className="bg-white p-3 rounded-md mb-6 shadow-md">
            {!loading && (
                <>
                    <section className="mb-4">
                        <Banner data={data} />
                    </section>

                    <section className="mb-4">
                        <Thumbnail data={data} />
                    </section>

                    <section className="mb-4">
                        <Static data={data} />
                    </section>

                    <FormContainer data={data} />
                </>
            )}

            {loading && (
                <div className="text-center py-8">
                    <VscLoading className="text-6xl animate-spin text-blue-600" />
                </div>
            )}
        </div>
    );
};

export default EditArticleContainer;
